import Navbar from "./Navbar";
import Footer from "./Footer";
import { useEffect } from "react";
import { trackAnalyticsEvent } from "../../services/analyticsService";

export default function WebsiteLayout({ children }) {
  useEffect(() => {
    try {
      Promise.resolve(trackAnalyticsEvent("visit")).catch(() => {});
    } catch (e) {}

    function handleClick(event) {
      try {
        const link = event.target.closest("a[href]");
        if (!link) return;
        const href = link.getAttribute("href") || "";
        if (href.startsWith("tel:")) {
          Promise.resolve(trackAnalyticsEvent("call_click", { location: link.textContent.trim().slice(0, 80) })).catch(() => {});
        }
        if (href.includes("wa.me")) {
          Promise.resolve(trackAnalyticsEvent("whatsapp_click", { location: link.textContent.trim().slice(0, 80) })).catch(() => {});
        }
      } catch (e) {}
    }
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);
  return (
    <>
      <Navbar />
      {children}
      <Footer />
      <a
        className="wa-float"
        href="https://wa.me/918320342657"
        target="_blank"
        rel="noreferrer"
        title="Chat on WhatsApp"
      >
        <svg className="icon" aria-hidden="true">
          <use href="#ic-whatsapp" />
        </svg>
      </a>
    </>
  );
}
